import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "6.196",
  height: "3.88"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "data-name": "Path 8442 - Outline",
  d: "M5.414 0a.5.5 0 0 0-.354.146L3.095 2.105 1.136.146a.5.5 0 0 0-.707 0L.146.429a.5.5 0 0 0 0 .707l2.6 2.6a.5.5 0 0 0 .707 0l2.6-2.6a.5.5 0 0 0 0-.707L5.77.146A.5.5 0 0 0 5.414 0z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };